import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AboutUsPages } from 'src/app/models/aboutUs-pages.model';
import { AboutUsService } from 'src/app/services/about-us.service';

@Component({
    selector: 'app-support',
    templateUrl: './support.component.html',
    styleUrls: ['./support.component.css'],
    standalone: false
})
export class SupportComponent implements OnInit {
  aboutUsPages: AboutUsPages;
  img: string;
  constructor(private aboutUsService: AboutUsService,

  ) { }

  createImgPath = (serverPath: string) => {
    return this.aboutUsService.createImgPath(serverPath);
  }

  ngOnInit(): void {
    this.aboutUsService.getAll$().subscribe(x => {
      this.aboutUsPages = x.find(x => x.pageID == 3);
    });
  }

}

